import { gql } from "@apollo/client";

const ORDER_FIELDS = `
  id
  type
  status
  status_color
  total
  creation
  creation_date
  modification
  resume_txt
  delivery_type
  payed
  payment_type
  platform_name
  tip
  user {
    name
  }
  table {
    id
    is_active
    name
  }
  branch {
    id
    name
  }
`;

const MENU_FIELDS = `
  getProducts(status: 1) {
    id
    ind_id
    status
    status_web
    category {
      id
      name
    }
    price
    title
    snoozed
    zone_id
    images {
      url
    }
    ingredients {
      id
      name
      color
      icon
    }
    sizes {
      id
      name
      price
    }
    has_option
    has_size
    options {
      id
      id_ingredient
      price_mod
      ingredient {
        id
        name
        icon
        color
      }
    }
  }
  getCategories {
    id
    name
  }
`;

export const GETTABLES = gql`
  query getTables($branch: Int) {
    getTables(branch: $branch) {
      id
      branch_id
      partner_id
      is_active
      name
      order_id
    }
  }
`;

export const GETTABLES_WITH_MENU = gql`
  query getTablesWithMenu($branch: Int) {
    getTables(branch: $branch) {
      id
      branch_id
      partner_id
      is_active
      name
      order_id
    }
    ${MENU_FIELDS}
  }
`;

export const GETORDERS = gql`
  query getOrders($branch_id: Int, $limit: Int, $active: Boolean) {
    getOrders(branch_id: $branch_id, take: $limit, active: $active) {
      ${ORDER_FIELDS}
    }
  }
`;

export const GETORDERS_WITH_MENU = gql`
  query getOrdersWithMenu($branch_id: Int, $active_limit: Int, $past_limit: Int) {
    activeOrders: getOrders(branch_id: $branch_id, take: $active_limit, active: true) {
      ${ORDER_FIELDS}
    }
    pastOrders: getOrders(branch_id: $branch_id, take: $past_limit, active: false) {
      ${ORDER_FIELDS}
    }
    ${MENU_FIELDS}
  }
`;

export const GETORDERSPRODUCTS = gql`
  query getOrders($branch_id: Int) {
    getOrders(branch_id: $branch_id, active: true) {
      ${ORDER_FIELDS}
      products {
        id
        status
        size
        # ingredients
        qty
        qty_done
        ingredients_txt
        ingredients_opt
        name
        comments
        product {
          title
          category {
            singular
          }
          ingredients {
            id
          }
        }
      }
    }
  }
`;

export const GETORDERSPRODUCTS_WITH_MENU = gql`
  query getOrdersProductsWithMenu($branch_id: Int) {
    getOrders(branch_id: $branch_id, active: true) {
      ${ORDER_FIELDS}
      products {
        id
        status
        size
        qty
        qty_done
        ingredients_txt
        ingredients_opt
        name
        comments
        product {
          title
          category {
            singular
          }
          ingredients {
            id
          }
        }
      }
    }
    ${MENU_FIELDS}
  }
`;

export const GETPRODUCTS = gql`
  query getMenu {
    ${MENU_FIELDS}
  }
`;

export const ORDER_UPDATE_SUBSCRIPTION = gql`
  subscription orderUpdate {
    orderUpdate {
      ${ORDER_FIELDS}
      createdProducts
    }
  }
`;
